import {Injectable} from '@angular/core';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub} from '@generated-backend-types';
import CalendarByGroupContainer = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Events.Calendar.ByGroup.CalendarByGroupContainer;
import Event = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Event;

@Injectable()
export class EventCalendarByGroupService extends BaseApiEndpointService<CalendarByGroupContainer> {

  public forEvent(e: Event | string): void {
    const id = typeof e === 'string' ? e : e.id;
    this.endpoint = `/events/${id}/calendar/by-group`;
  }

  public modelToMultiSelectItem(m: CalendarByGroupContainer): ListItem & {model: CalendarByGroupContainer} {
    return {
      id: m.id,
      text: m.id,
      isDisabled: false,
      model: m,
    };
  }
}
